module.exports = __webpack_public_path__ + "img/hp5.48911b18.png";